import { NavLink, Outlet } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useRevenueGoals } from '@/hooks/useRevenue';

const revenueTabs = [
  { to: '/revenue', label: 'Consolidated', end: true },
  { to: '/revenue/display-video', label: 'Display & Video', end: false },
  { to: '/revenue/chatgpt-ads', label: 'ChatGPT Ads', end: false },
  { to: '/revenue/geo', label: 'GEO', end: false },
];

/** Revenue section: one tab per business line, plus the goals for the revenue admins. */
export function RevenueLayout() {
  const { data: goals } = useRevenueGoals();
  const tabs = goals?.canEdit
    ? [...revenueTabs, { to: '/revenue/goals', label: 'Goals', end: false }]
    : revenueTabs;

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4">
        <h1 className="adv-page-title">Revenue</h1>
        <nav className="adv-tabs">
          {tabs.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => cn('adv-tab', isActive && 'adv-tab--active')}
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
